<div class="main_body">
  <div class="contents contents--tou">
    <h2 class="contents__title" i18n="@@pages.termOfUse.title.main">利用規約</h2>
    <h5 i18n="@@pages.termOfUse.message.introduction">
      以下の利用規約をよくお読みいただき、同意の上でご利用ください。 医療機器版をお使いの方は医療機器版利用規約が適用され、それ以外の方はネックバンド版利用規約が適用されます。
    </h5>

  <div class="legal-page">

  <mat-card appearance="outlined">

    <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedTabIndex">
      <mat-tab label="医療機器版利用規約">

        <h2>医療機器版GOKURIサービス利用規約</h2>
        <p>本規約は、PLIMES株式会社（以下「当社」という。）が提供する「GOKURI 頸部装着型電子聴診器」ならび「GOKURI
          クラウド」のGOKURIサービス（以下「本サービス」という。）の利用に関し、本サービスの利用契約（第2条に定める。以下同様とする。）を締結し、本サービスを利用する事業者（以下「利用者」という。）に適用されるものです。
        </p>

        <h2>第1条 （本サービスの内容）</h2>
        <p>
          本サービスは、次の各号をその内容とし、利用者との契約内容に応じて、当社から利用者に対して提供されます（第1号から第3号の内容を併せて「本機器等」という。）。なお、本サービスの詳細は、別途本サービスに係るウェブサイト、関連する契約、利用マニュアルその他に定める内容（以下総称して「ご案内」という。）に従うものとします。
        </p>
        <ol class="no-style-list">
          <li>(1) 「GOKURI 頸部装着型電子聴診器」：当社が提供する嚥下音及び頸部からの生体情報を計測するためのネックバンド型ウェアラブルデバイス</li>
          <li>(2) 専用端末及び通信回線の貸与</li>
          <li>(3) 専用端末又は利用者のスマートフォンにおけるGOKURIアプリケーションの利用（以下「本機器」という。）</li>
          <li>(4) 専用端末に含まれる遠隔モバイルデバイス管理ツール</li>
          <li>(5) web（当社が提供するクラウド）を介したデータ閲覧及びダウンロード</li>
        </ol>

        <h2>第2条 （利用契約の締結）</h2>
        <p>1.
          本サービスの利用契約（以下「利用契約」という。）は、本サービスの利用を希望する事業者（以下「利用申込者」という。）が、当社所定の書式（以下「申込フォーム」という。）により本サービスの利用を申し込み、当社が、これに対し所定の方法により申込みの確認を行った上で、承諾の通知を発信したときに成立します。なお、本サービスの利用申込者は本規約の内容を承諾の上、かかる申込を行うものとし、利用申込者が申込を行った時点で、当社は利用申込者が本規約の内容を承諾しているものとみなします。
        </p>
        <p>2.
          利用契約の存続期間は、前項の規定に基づく利用契約が成立した日より、申込フォームに定める期間とします。期間満了の30日前までに利用者又は当社からなんら申し出が無い場合は、別紙料金表に定める価格にて自動で更新されるものとし、以後も同様とします。
        </p>
        <p>3.
          利用契約の存続期間中に契約を解除する場合には、解約希望日の30日前までにその旨を当社に書面にて通知するとともに、利用契約の解除に関する覚書を交わしたうえで、利用料の総額から支払い済みの料金を控除した額を支払わねばなりません。
        </p>

        <h2>第3条 （本サービスの利用条件・禁止事項）</h2>
        <p>1.
          利用者は、本サービスを利用するにあたって次の各号に定める事項をあらかじめ承諾の上遵守し、実際に本機器等を通じて本機器等の被計測者（以下「被計測者」という。）の情報（被計測者の肖像を含む。）がデータとして外部に保管されること及び当該データを当社の事業における市場調査、商品開発（他社との共同開発を含む。）及び学会論文作成や発表等のために当社が利用することを理解し、かつ、被計測者にも理解させ同意を取得した上で利用するものとします。
        </p>
        <ol class="no-style-list">
          <li>(1) 医薬品、医療機器等の品質、有効性及び安全性の確保等に関する法律等の法令に抵触してはならない。</li>
          <li>(2) 当社の指示に従い本機器等を適切に利用及び管理しなければならない。</li>
          <li>(3) 本機器を摂食嚥下以外の記録の用途に用いてはならない。</li>
          <li>(4) 本機器等に異常が発生した場合、当社の指示に従い本機器等のメンテナンスを行わなければならない。</li>
          <li>(5) 当社の求めに応じて当社が実施する本機器等の利用状況に関するヒアリングに可能な範囲で協力するものとする。</li>
          <li>(6) 別途定める本機器等の利用期間又は利用契約が終了した時点において、当社の指示に従い本機器等を返却しなければならない。</li>
          <li>(7) 被計測者の嚥下に関する記録及びその他関連情報（(i)被計測者の摂食時・就寝時・日常生活時における嚥下音、呼吸音、会話等の音声及び動画の情報並びに頸部の角度
            の情報、(ii)計測時点及びそれ以前における、被計測者の摂食物及び飲用物に関する情報、食事及び日常生活での身体の姿勢、体重や運動等の身体情報、口腔機能に関する情報、(iii)専門家の所見等、を含む。以下「嚥下記録情報」という。）(iiii)
            本機器の位置情報（詳細は、第6条4項に定めるプライバシーポリシーをご確認ください。）を記録するものとする。</li>
          <li>(8) 自己の費用と責任において、本サービスの利用に必要な自己の設備を準備、設定し維持しなければならない。</li>
        </ol>
        <p>2. 利用者は、本規約の他の条文で禁止する行為のほか、次の各号に定める行為を行ってはなりません。また、利用者は、被計測者に対しても、本項の規定を同様に遵守させなければなりません。</p>
        <ol class="no-style-list">
          <li>(1) 本サービスを利用している事実を悪用する行為</li>
          <li>(2) 当社の名誉、信用を傷つけるような行為</li>
          <li>(3) 当社になりすます行為</li>
          <li>(4) 当社の事前の承諾無く、営業、宣伝、広告、勧誘等の目的で当社の名称を使用する行為</li>
          <li>(5) 営業、宣伝、広告、勧誘等の目的で、不正確な内容で本サービスの名称を使用する行為</li>
          <li>(6) 本サービスの運営を妨げる行為</li>
          <li>(7)
            本製品について、正常な動作を妨げるような不正行為、不正アクセス行為、他者が本サービスの利用に際して作成したアカウント、パスワード又はID（以下「パスワード等」という。）の使用行為その他前項で許諾された範囲を超えた使用（複製、送信、転載、改変、改造等の行為も含む。）に当たる行為
          </li>
          <li>(8) 当社の著作権、商標権、特許権等の知的財産権等法令上又は契約上の権利を侵害する行為</li>
          <li>(9) 本機器等に含まれ又は使用されるシステム又はソフトウェアに対する逆コンパイル、リバースエンジニアリング等当該システム又はソフトウェアを解析する行為及び当該ソフトウェアの派生物を作成する行為</li>
          <li>(10) 前各号の行為を援助又は助長する行為</li>
          <li>(11) 前各号のほか、当社が不適切と判断する行為</li>
        </ol>

        <h2>第4条 （パスワード等の管理）</h2>
        <p>1. 利用者は、パスワード等を第三者に不正に利用されないよう利用者自身で厳重に管理しなければなりません。当社は、登録されたパスワード等を利用して行われた行為は、全て利用者が行ったものとみなします。</p>
        <p>2. 本サービスのパスワード等は第三者に譲渡又は貸与してはならないものとします。</p>
        <p>3. 利用契約が終了した場合には、当社は利用者のパスワード等を、事前の通知無く削除することができます。</p>

        <h2>第5条 （通知）</h2>
        <p>1. 当社から利用者への通知は、通知内容を電子メール、書面又は本サービスのホームページに掲載する等、当社が適当と判断する方法により行います。</p>
        <p>2.
          前項の規定に基づき、当社から利用者への通知を電子メールの送信又は本サービスのホームページへの掲載の方法により行う場合には、利用者に対する当該通知は、それぞれ電子メールの送信又は本サービスのホームページへの掲載がなされた時点から効力を生じます。
        </p>

        <h2>第6条 （個人情報等の取扱い）</h2>
        <p>1. 本規約において「個人情報」とは、個人情報の保護に関する法律（平成15年法律第57号）第2条第1項に定める個人情報をいいます。</p>
        <p>2.
          利用者は、本サービスの利用に伴い当社へ被計測者の個人情報が提供される事実及び第４項で定める被計測者向けのプライバシーポリシーについて、本サービスの利用開始に先立ち被計測者からの承諾を得なければならないものとします。利用者は、当社から要求があった場合には、当該承諾を得たことを証明する書面又は電磁的記録を当社に確認させるものとします。
        </p>
        <p>3. 当社は、個人情報を、個人情報の保護に関する法律、これに関連する法令及びガイドラインに則って保護するものとし、必要なセキュリティ対策を講じ、厳重に管理（廃棄、消去等の処理を含みます。）を行います。</p>
        <p>
          4. 当社は、利用者及び被計測者の個人情報を次に掲げる
          プライバシーポリシーに従って取り扱います。なお、各プライバシーポリシーについては
          最終改訂日時点において、下記URLから確認することができます。
        </p>

        <ul>
          <li>
            GOKURIサービスユーザープライバシーポリシー<br>
            <a [routerLink]="['/privacy']" [queryParams]="{ tab: 'user' }" target="_blank" rel="noopener noreferrer">
              https://www.app.gokuri.com/privacy?tab=user
            </a>
          </li>
          <li>
            GOKURIサービススタッフプライバシーポリシー<br>
            <a [routerLink]="['/privacy']" [queryParams]="{ tab: 'staff' }" target="_blank" rel="noopener noreferrer">
              https://www.app.gokuri.com/privacy?tab=staff
            </a>
          </li>
        </ul>

        <h2>第7条 （使用料及び支払方法）</h2>
        <p>1. 利用者は、本サービスの使用料（本機器等の使用料を含む。）として、別途合意する金額（消費税額別途）を支払うものとする。</p>
        <p>2. 当社は、利用者に対して、前項の使用料に関する請求書を、利用契約成立後に交付する。</p>
        <p>3. 利用者は、前項の請求書を受理した日から４０日以内に、当社に対し使用料を支払うものとする。</p>

        <h2>第8条 （ユーザーサポート）</h2>
        <p>1. 本サービスのサポートは、利用者のみを対象とし、お問い合わせは、当社のユーザーサポート窓口にて、当社所定の営業時間内で受け付けます。</p>
        <p>2. お問い合わせの内容によっては、回答が遅れたり、回答できないことがある旨を返答したりする場合があります。</p>

        <h2>第9条 （知的財産）</h2>
        <p>1. 本規約において、利用者は、本サービスを利用することによって、本サービス、本機器等及び本サービスにより提供されるデータに対するいかなる知的財産権も取得することはありません。</p>
        <p>2. 利用者は、本規約が、当社が単独で遂行可能な知的財産権の取得若しくは新製品の開発等を規制するものではないことを確認します。</p>
        <p>3. 当社が嚥下記録情報を利用する過程で生じた知的財産権（以下「本件知的財産権」という。）は、原則として当社の単独所有又は当社の指定する第三者との共有とします。</p>
        <p>4.
          利用者は、自ら及び利用者の役職員をして、当社及び当社の指定する第三者に対し、利用者又は利用者の役職員が本サービスに関して新たに創作し、又は本サービスを利用する過程で生じた一切の資料、データ及び情報（嚥下記録情報を含みますがこれに限られません。以下、総称して「提供データ」という。）について、全世界において、期間の制約なく、目的、方法、態様を問わず利用（翻案、改変、将来開発される媒体での利用を含むがこれらに限られません。）することを非独占的かつ無償で許諾します。
        </p>
        <p>5. 利用者は、当社及び当社の指定する第三者に対し、提供データに関する著作者人格権その他の人格権を行使しないことに同意し、かつ、利用者の役職員に同意させるものとします。</p>

        <h2>第10条 （守秘義務）</h2>
        <p>1.
          当社及び利用者は、本サービスの利用を通じて知り得た本サービスの内容、本製品の性能・機能、その他の客観的にみて秘密と扱うべき情報（以下「秘密情報」という。）について、厳重に管理し、相手方からの書面による事前の承諾無く、第三者に開示・漏洩し、又は利用契約の履行以外の目的に使用してはなりません。
        </p>
        <p>2. 次のいずれかに該当するものは、秘密情報に含まれません。</p>
        <ol class="no-style-list">
          <li>(1) 知得又は開示を受けたときに既に公知であったもの</li>
          <li>(2) 知得又は開示を受けた後、利用者の責に帰さない事由により公知となったことを証明したもの</li>
          <li>(3) 正当な権利を有する第三者からなんらの秘密保持義務を課せられることなく取得したもの</li>
          <li>(4) 知得又は開示を受けた情報によらずに独自に開発したもの</li>
        </ol>
        <p>3.
          第1項の定めにかかわらず、当社及び利用者は相手方からの書面による事前の承諾無く、秘密情報を知る必要がある弁護士、会計士、税理士その他法令上の守秘義務を負うアドバイザー（以下「外部専門家」という。）及び被計測者に対して、秘密情報を開示することができます。この場合において、当社及び利用者は、秘密情報の開示を受けた外部専門家及び被計測者をして本契約上の義務と同様の義務を負わせなければなりません。
        </p>
        <p>4.
          第1項の定めにかかわらず、行政当局、司法機関その他の公的機関、金融商品取引所等から、法令（金融商品取引所の定める規則も含む。）上の権限に基づき開示請求があった場合、当社及び利用者は、当該秘密情報を開示することができます。この場合において、可能な範囲で事前に相手方への通知を行わなければなりません。
        </p>
        <p>5. 本条の規定は、利用契約の終了後も引き続き効力を有するものとします。</p>

        <h2>第11条 （本規約等の変更）</h2>
        <p>1. 当社は、必要と判断した場合には、本規約又は本サービスの内容をいつでも変更できます。ただし、第6条（個人情報等の取扱い）及び第10条（守秘義務）の規定は、この限りではありません。</p>
        <p>2. 本規約の内容を変更する場合、当社は事前に、利用者に対し当該変更を通知します。なお、当該変更後も利用者が本サービスの利用を継続した場合、利用者は当該変更に対して取り消し不可能な承諾をしたものとみなされます。
        </p>

        <h2>第12条 （サービス提供の一時中断又は停止等）</h2>
        <p>1. 当社は、次の各号のいずれかに該当する場合には、利用者への事前の通知又は承諾を要することなく、本サービスの提供を一時中断することができます。</p>
        <ol class="no-style-list">
          <li>(1) 本サービスに係る設備、機器の故障等により保守又は点検作業を行う場合</li>
          <li>(2) 利用者のパスワード等が第三者に使用された場合</li>
          <li>(3) 運用上又は技術上の理由でやむを得ない場合</li>
          <li>(4) 本製品に係る改善作業を行う場合</li>
          <li>(5) 戦争、暴動、労働争議、天災地変（地震、噴火、洪水、津波等）、火災、停電その他の非常事態により、本サービスの提供ができなくなった場合</li>
          <li>(6) その他当社が必要と認めた場合</li>
        </ol>
        <p>2. 当社は、次の各号のいずれかに該当する場合、利用者に通知の上直ちに本サービスの利用を停止し、パスワード等の削除、利用契約の解除その他の措置を取ることができます。</p>
        <ol class="no-style-list">
          <li>(1) 利用者が本規約又は利用契約の定めに違反したとき</li>
          <li>(2) 第6条第2項に定める個人情報の提供に係る承諾が得られていないことが明らかとなったとき</li>
          <li>(3) 利用料の支払いが2回連続で遅延したとき</li>
          <li>(4) 利用者に重大な財務状況の悪化が認められる相当の事情が生じたとき</li>
          <li>(5) 利用者が届け出た情報に基づく当社と利用者との連絡が2ヶ月間、不可能なとき</li>
          <li>(6) 利用者及び被計測者に関して利用者が届け出た情報について、不正な利用又は虚偽の申告等、不適切な行為があったとき</li>
          <li>(7) 当社の責に帰さない事由により、本サービスの提供が事実上不可能になったとき</li>
          <li>(8) その他合理的な事由により、本サービスの利用者として不適切と当社が判断したとき</li>
        </ol>
        <p>3.
          当社は、前各項に定める事由のいずれかにより本サービス提供の中断若しくは停止又は利用契約の解除をしたことに関して利用者、被計測者又はその他の第三者が損害を被った場合であっても、なんら法的な義務及び責任を負わないものとします。
        </p>
        <p>4. 利用者は、第2項に定める事由のいずれかにより利用契約が解除された場合、解除時点までの未払いの利用料全額を支払わなければなりません。</p>
        <p>5. 当社は、事業上の理由等当社が必要と認めた場合、事前に利用者に通知のうえ、本サービスを停止し、利用契約を解除することができます。この場合において、当社は、なんら法的な義務及び責任を負わないものとします。
        </p>

        <h2>第13条 （本サービスの中止）</h2>
        <p>1. 当社は、理由の如何にかかわらず、利用者に対する通知の上、本サービスの提供を中止することができます。</p>
        <p>2. 前項に定める通知は、本サービスの提供中止の60日前までに、第5条の定めに従い、本サービスのホームページ上にその旨掲載することによって行います。</p>
        <p>3. 当社は本サービスの提供中止の際、本条に定める手続を経ることで、中止に伴う利用者又は第三者に対する損害賠償その他一切の責任を免れるものとします。</p>

        <h2>第14条 （本サービスの提供主体の変更）</h2>
        <p>
          当社は、事業譲渡、会社分割その他方法の如何を問わず、本サービスの提供主体を第三者である法人、組織団体又は当社の後継組織（以下「変更先」という。）に変更できるものとします。このとき、変更先は、当社が利用者に対して持つ全ての権利及び義務並びにパスワード等その他の利用者に関する情報及び利用情報を引き継ぐことができるものとし、利用者は、かかる権利、義務及び情報の移転につき予め同意するものとします。その場合、当社は、利用者に対し、本サービスの提供主体の変更の１ヶ月前までに、第5条の定めに従って通知するものとします。
        </p>

        <h2>第15条 （無保証）</h2>
        <p>1. 当社は、本サービス並びに本サービスに含まれる本機器等及びデータの品質、機能、有用性、妥当性、その他あらゆる面に関して、一切の表明や保証を行いません。</p>
        <p>2.
          当社は、本サービスの安全性、完全性及び信頼性並びに本サービスの利用による被計測者の健康状態の良化を保証するものではなく、利用者が本サービスを利用した結果及び被計測者が実際に本製品を使用した結果について、なんら法的な義務及び責任を負わないものとします。
        </p>
        <p>3. 利用者は、本機器等の利用に際して、本機器等において提供される情報やサービスの有用性等を自ら判断し、自己の責任で利用するものとします。</p>
        <p>4. 当社は、次の各号について、一切保証しないものとします。</p>
        <ol class="no-style-list">
          <li>(1) 本サービス及び本機器等において提供される全ての情報に関する、有用性、適合性、完全性、正確性、安全性、合法性、最新性等</li>
          <li>(2) 利用者が本機器等上において提供される情報を利用して第三者と交渉又は予約、もしくは契約の申込又は締結等を行う場合において、当該行為に関する一切</li>
          <li>(3) 本サービス及び本機器等を通じて入手できる商品、役務、情報等が利用者の希望又は期待を満たす適切なものであること</li>
          <li>(4) 本サービス及び本機器等の提供に不具合、エラー又は障害が生じないこと</li>
          <li>(5) 本サービス及び本機器等に関連して送信される電子メール、ウェブコンテンツ等に、コンピュータ・ウィルス等の有害なものが含まれていないこと</li>
        </ol>

        <h2>第16条 （責任の範囲）</h2>
        <p>1. 本サービスには、当社が提供するサービス又は情報を含みます。その場合には、当該サービス又は情報には、各事業者が定める利用規約又は契約その他の条件が適用され、その責任は、これを提供する事業者が負います。
        </p>
        <p>2. 当社は、本規約若しくは本サービスの変更又は利用者が当社からの通知の確認を怠ったことにより損害を被った場合であっても、なんら法的な義務及び責任を負わないものとします。</p>
        <p>3. 利用者は、には、自己の費用と責任において一切を処理するものとし、当社は当該紛争につきなんら責任を負わないものとします。</p>
        <p>4.
          当社は、利用者の本サービス及び本機器等の利用（これらに伴う当社又は第三者による情報提供行為等を含み、これらに限られない。）又は利用不能により生じる一切の損害（本項各号に定める損害や、前項により利用者又は第三者に生じた損害、精神的苦痛、又はその他の金銭的損失を含み、これらに限られない）につき、当社に故意又は重過失がない限り、一切その責任を負わないものとする。
        </p>
        <ol class="no-style-list">
          <li>(1) 本機器等の無断改変、本機器等に関するデータへの不正アクセス、コンピュータ・ウィルスの混入等の不正行為が行われ、これに起因して利用者に生じた損害</li>
          <li>(2) 天災、火災、停電等不可抗力、システムの保守、通信回線やコンピューターの障害等による、当社のサーバーやシステム、本機器等の中断、遅延、中止、データ消失等により生じた損害</li>
          <li>(3) 本機器等において提供されるサービスの利用にあたって、利用者と第三者との間で生じたトラブルにより生じた損害並びに、本サービスの利用に関連して、被計測者又は第三者との間に紛争が生じた場合</li>
        </ol>
        <p>5. 本サービスの提供に関し、当社の過失により利用者が受けた損害を賠償する場合、当社は直接かつ通常生じる損害の範囲で賠償するものとします。</p>

        <h2>第17条 （反社会的勢力）</h2>
        <p>1. 利用者は、次の各号に該当しないことを表明保証し、将来にわたり該当しないことを誓約するものとします。</p>
        <ol class="no-style-list">
          <li>(1)
            自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が、暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団その他これらに準ずるもの（以下総称して「反社会的勢力」という。）であること。
          </li>
          <li>(2) 自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が反社会的勢力と社会的に非難されるべき関係を有すること。</li>
          <li>(3) 前二号に該当しなくなったときから5年を経過していないこと。</li>
          <li>(4) 自ら又は第三者を利用して、当社に対し、次に掲げる行為又はこれに準ずる行為を行うこと。
            <ol class="no-style-list">
              <li>(a) 暴力的な要求行為</li>
              <li>(b) 法的な責任を超えた不当な要求行為</li>
              <li>(c) 取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
              <li>(d) 風説を流布し、偽計を用い又は威力を用いて、当社の信用を毀損し、又は当社の業務を妨害する行為</li>
            </ol>
          </li>
        </ol>
        <p>2.
          当社は、利用者が前項に違反している懸念が生じた場合は、随時調査を実施し、利用者に対して調査への協力及び資料の提出を求めることができます。この場合において、利用者は、調査に合理的な範囲で協力し、その範囲内で要請を受けた資料を提出しなければならないものとします。
        </p>
        <p>3. 利用者は、第1項に違反した場合、直ちに当社に通知しなければなりません。</p>
        <p>4. 当社は、利用者が次の各号のいずれかに該当する場合、催告することなく利用契約を解除できるものとします。この場合において、利用者に損害が生じた場合でも、当社はこれを賠償する責任を負いません。</p>
        <ol class="no-style-list">
          <li>(1) 第1項に違反したとき。</li>
          <li>(2) 第1項に違反している懸念が生じ、それにより利用契約を継続し難い状況が生じたとき。</li>
        </ol>
        <p>5. 本条は、利用契約の終了後も引き続き3年間効力を有するものとします。</p>

        <h2>第18条 （管轄裁判所）</h2>
        <p>本規約及び利用契約に関する紛争解決のための準拠法は日本法とし、第一審の専属的合意管轄裁判所は、東京地方裁判所とします。</p>

        <h2>第19条 （疑義の解決）</h2>
        <p>本規約に定めのない事項又は疑義を生じた事項については、その都度利用者と当社の間で協議し、誠意をもって解決するものとします。</p>

        <p class="align-right">（以上）</p>

        <h2>附則</h2>
        <p>本規約は2024年8月1日から実施します。</p>


      </mat-tab>

      <mat-tab label="ヘルスケア版利用規約">

        <h2>ヘルスケア版GOKURIサービス利用規約</h2>
        <p>本規約は、PLIMES株式会社（以下「当社」という。）が提供する「GOKURI ネックバンド」ならび「GOKURI
          クラウド」のGOKURIサービス（以下「本サービス」という。）の利用に関し、本サービスの利用契約（第2条に定める。以下同様とする。）を締結し、本サービスを利用する事業者（以下「利用者」という。）に適用されるものです。
        </p>

        <h2>第1条 （本サービスの内容）</h2>
        <p>
          本サービスは、次の各号をその内容とし、利用者との契約内容に応じて、当社から利用者に対して提供されます（第1号から第3号の内容を併せて「本機器等」という。）。なお、本サービスの詳細は、別途本サービスに係るウェブサイト、関連する契約、利用マニュアルその他に定める内容（以下総称して「ご案内」という。）に従うものとします。
        </p>
        <ol class="no-style-list">
          <li>(1) 「GOKURI ネックバンド」：当社が提供する嚥下音及び頸部からの生体情報を計測するためのネックバンド型ウェアラブルデバイス</li>
          <li>(2) 専用端末及び通信回線の貸与</li>
          <li>(3) 専用端末又は利用者のスマートフォンにおけるGOKURIアプリケーションの利用（以下「本機器」という。）</li>
          <li>(4) 専用端末に含まれる遠隔モバイルデバイス管理ツール</li>
          <li>(5) web（当社が提供するクラウド）を介したデータ閲覧及びダウンロード</li>
        </ol>

        <h2>第2条 （利用契約の締結）</h2>
        <p>1.
          本サービスの利用契約（以下「利用契約」という。）は、本サービスの利用を希望する事業者（以下「利用申込者」という。）が、当社所定の書式（以下「申込フォーム」という。）により本サービスの利用を申し込み、当社が、これに対し所定の方法により申込みの確認を行った上で、承諾の通知を発信したときに成立します。なお、本サービスの利用申込者は本規約の内容を承諾の上、かかる申込を行うものとし、利用申込者が申込を行った時点で、当社は利用申込者が本規約の内容を承諾しているものとみなします。
        </p>
        <p>2.
          利用契約の存続期間は、前項の規定に基づく利用契約が成立した日より、申込フォームに定める期間とします。期間満了の30日前までに利用者又は当社からなんら申し出が無い場合は、別紙料金表に定める価格にて自動で更新されるものとし、以後も同様とします。
        </p>
        <p>3.
          利用契約の存続期間中に契約を解除する場合には、解約希望日の30日前までにその旨を当社に書面にて通知するとともに、利用契約の解除に関する覚書を交わしたうえで、利用料の総額から支払い済みの料金を控除した額を支払わねばなりません。
        </p>

        <h2>第3条 （本サービスの利用条件・禁止事項）</h2>
        <p>1.
          利用者は、本サービスを利用するにあたって次の各号に定める事項をあらかじめ承諾の上遵守し、実際に本機器等を通じて本機器等の被計測者（以下「被計測者」という。）の情報（被計測者の肖像を含む。）がデータとして外部に保管されること及び当該データを当社の事業における市場調査、商品開発（他社との共同開発を含む。）及び学会論文作成や発表等のために当社が利用することを理解し、かつ、被計測者にも理解させ同意を取得した上で利用するものとします。
        </p>
        <ol class="no-style-list">
          <li>(1)
            医薬品、医療機器等の品質、有効性及び安全性の確保等に関する法律等の法令に抵触してはならず、本機器等が医療機器に該当するものではないことを理解するとともに、診断及び診療を目的として本機器等を使用してはならない。
          </li>
          <li>(2) 当社の指示に従い本機器等を適切に利用及び管理しなければならない。</li>
          <li>(3) 本機器を摂食嚥下以外の記録の用途に用いてはならない。</li>
          <li>(4) 本機器等に異常が発生した場合、当社の指示に従い本機器等のメンテナンスを行わなければならない。</li>
          <li>(5) 当社の求めに応じて当社が実施する本機器等の利用状況に関するヒアリングに可能な範囲で協力するものとする。</li>
          <li>(6) 別途定める本機器等の利用期間又は利用契約が終了した時点において、当社の指示に従い本機器等を返却しなければならない。</li>
          <li>(7)
            被計測者の嚥下に関する記録及びその他関連情報（(i)被計測者の摂食時・就寝時・日常生活時における嚥下音、呼吸音、会話等の音声の情報及び頸部の角度の情報、(ii)計測時点及びそれ以前における、被計測者の摂食物及び飲用物に関する情報、食事及び日常生活での身体の姿勢、体重や運動等の身体情報、口腔機能に関する情報、(iii)専門家の所見等、を含む。以下「嚥下記録情報」という。）を記録するものとする。
          </li>
          <li>(8) 自己の費用と責任において、本サービスの利用に必要な自己の設備を準備、設定し維持しなければならない。</li>
        </ol>
        <p>2. 利用者は、本規約の他の条文で禁止する行為のほか、次の各号に定める行為を行ってはなりません。また、利用者は、被計測者に対しても、本項の規定を同様に遵守させなければなりません。</p>
        <ol class="no-style-list">
          <li>(1) 本サービスを利用している事実を悪用する行為</li>
          <li>(2) 当社の名誉、信用を傷つけるような行為</li>
          <li>(3) 当社になりすます行為</li>
          <li>(4) 当社の事前の承諾無く、営業、宣伝、広告、勧誘等の目的で当社の名称を使用する行為</li>
          <li>(5) 営業、宣伝、広告、勧誘等の目的で、医療機器と誤認される内容などの不正確な内容で本サービスの名称を使用する行為</li>
          <li>(6) 本サービスの運営を妨げる行為</li>
          <li>(7)
            本製品について、正常な動作を妨げるような不正行為、不正アクセス行為、他者が本サービスの利用に際して作成したアカウント、パスワード又はID（以下「パスワード等」という。）の使用行為その他前項で許諾された範囲を超えた使用（複製、送信、転載、改変、改造等の行為も含む。）に当たる行為
          </li>
          <li>(8) 当社の著作権、商標権、特許権等の知的財産権等法令上又は契約上の権利を侵害する行為</li>
          <li>(9) 本機器等に含まれ又は使用されるシステム又はソフトウェアに対する逆コンパイル、リバースエンジニアリング等当該システム又はソフトウェアを解析する行為及び当該ソフトウェアの派生物を作成する行為</li>
          <li>(10) 前各号の行為を援助又は助長する行為</li>
          <li>(11) 前各号のほか、当社が不適切と判断する行為</li>
        </ol>
        <h2>第4条 （パスワード等の管理）</h2>
        <p>
          1.
          利用者は、パスワード等を第三者に不正に利用されないよう利用者自身で
          厳重に管理しなければなりません。当社は、登録されたパスワード等を利用して
          行われた行為は、全て利用者が行ったものとみなします。
        </p>
        <p>
          2.
          本サービスのパスワード等は第三者に譲渡又は貸与してはならないものとします。
        </p>
        <p>
          3.
          利用契約が終了した場合には、当社は利用者のパスワード等を、
          事前の通知無く削除することができます。
        </p>

        <h2>第5条 （通知）</h2>
        <p>
          1.
          当社から利用者への通知は、通知内容を電子メール、書面又は
          本サービスのホームページに掲載する等、当社が適当と判断する方法により行います。
        </p>
        <p>
          2.
          前項の規定に基づき、当社から利用者への通知を電子メールの送信又は
          本サービスのホームページへの掲載の方法により行う場合には、
          利用者に対する当該通知は、それぞれ電子メールの送信又は
          本サービスのホームページへの掲載がなされた時点から効力を生じます。
        </p>

        <h2>第6条 （個人情報等の取扱い）</h2>
        <p>
          1.
          本規約において「個人情報」とは、個人情報の保護に関する法律
          （平成15年法律第57号）第2条第1項に定める個人情報をいいます。
        </p>
        <p>
          2.
          利用者は、本サービスの利用に伴い当社へ被計測者の個人情報が提供される事実
          及び第４項で定める被計測者向けのプライバシーポリシーについて、
          本サービスの利用開始に先立ち被計測者からの承諾を得なければならないものとします。
          利用者は、当社から要求があった場合には、当該承諾を得たことを証明する書面又は
          電磁的記録を当社に確認させるものとします。
        </p>
        <p>
          3.
          当社は、個人情報を、個人情報の保護に関する法律、これに関連する法令及び
          ガイドラインに則って保護するものとし、必要なセキュリティ対策を講じ、
          厳重に管理（廃棄、消去等の処理を含みます。）を行います。
        </p>
        <p>
          4.
          当社は、利用者及び被計測者の個人情報を次に掲げるプライバシーポリシーに
          従って取り扱います。なお、各プライバシーポリシーについては
          最終改訂日時点において、次に掲げるURLから確認することができます。
        </p>
        <ul>
          <li>
            GOKURIサービスユーザープライバシーポリシー<br>
            <a [routerLink]="['/privacy']" [queryParams]="{ tab: 'user' }" target="_blank" rel="noopener noreferrer">
              https://www.app.gokuri.com/privacy?tab=user
            </a>
          </li>
          <li>
            GOKURIサービススタッフプライバシーポリシー<br>
            <a [routerLink]="['/privacy']" [queryParams]="{ tab: 'staff' }" target="_blank" rel="noopener noreferrer">
              https://www.app.gokuri.com/privacy?tab=staff
            </a>
          </li>
        </ul>

        <h2>第7条 （使用料及び支払方法）</h2>
        <p>1.	利用者は、本サービスの使用料（本機器等の使用料を含む。）として、別途合意する金額（消費税額別途）を支払うものとする。
        </p>
        <p>2.	当社は、利用者に対して、前項の使用料に関する請求書を、利用契約成立後に交付する。
        </p>
        <p>3.	利用者は、前項の請求書を受理した日から４０日以内に、当社に対し使用料を支払うものとする。
        </p>

        <h2>第8条 （ユーザーサポート）</h2>
        <p>
          1.	本サービスのサポートは、利用者のみを対象とし、お問い合わせは、当社のユーザーサポート窓口にて、当社所定の営業時間内で受け付けます。
        </p>
        <p>
          2.	お問い合わせの内容によっては、回答が遅れたり、回答できないことがある旨を返答したりする場合があります。
        </p>

        <h2>第9条 （知的財産）</h2>
        <p>
          1.
          本規約において、利用者は、本サービスを利用することによって、
          本サービス、本機器等及び本サービスにより提供されるデータに対する
          いかなる知的財産権も取得することはありません。
        </p>
        <p>
          2.
          利用者は、本規約が、当社が単独で遂行可能な知的財産権の取得若しくは
          新製品の開発等を規制するものではないことを確認します。
        </p>
        <p>
          3.
          当社が嚥下記録情報を利用する過程で生じた知的財産権
          （以下「本件知的財産権」という。）は、原則として当社の単独所有又は
          当社の指定する第三者との共有とします。
        </p>
        <p>
          4.
          利用者は、自ら及び利用者の役職員をして、当社及び当社の指定する第三者に対し、
          利用者又は利用者の役職員が本サービスに関して新たに創作し、
          又は本サービスを利用する過程で生じた一切の資料、データ及び情報
          （嚥下記録情報を含みますがこれに限られません。以下、総称して「提供データ」という。）
          について、全世界において、期間の制約なく、目的、方法、態様を問わず利用
          （翻案、改変、将来開発される媒体での利用を含むがこれらに限られません。）
          することを非独占的かつ無償で許諾します。
        </p>
        <p>
          5.
          利用者は、当社及び当社の指定する第三者に対し、提供データに関する著作者人格権
          その他の人格権を行使しないことに同意し、かつ、利用者の役職員に同意させるものとします。
        </p>

        <h2>第10条 （守秘義務）</h2>
        <p>
          1.
          当社及び利用者は、本サービスの利用を通じて知り得た本サービスの内容、
          本製品の性能・機能、その他の客観的にみて秘密と扱うべき情報
          （以下「秘密情報」という。）について、厳重に管理し、
          相手方からの書面による事前の承諾無く、第三者に開示・漏洩し、
          又は利用契約の履行以外の目的に使用してはなりません。
        </p>
        <p>
          2.
          次のいずれかに該当するものは、秘密情報に含まれません。
        </p>
        <ol class="no-style-list">
          <li>(1) 知得又は開示を受けたときに既に公知であったもの</li>
          <li>(2) 知得又は開示を受けた後、利用者の責に帰さない事由により公知となったことを証明したもの</li>
          <li>(3) 正当な権利を有する第三者からなんらの秘密保持義務を課せられることなく取得したもの</li>
          <li>(4) 知得又は開示を受けた情報によらずに独自に開発したもの</li>
        </ol>
        <p>
          3.
          第1項の定めにかかわらず、当社及び利用者は相手方からの書面による事前の承諾無く、
          秘密情報を知る必要がある弁護士、会計士、税理士その他法令上の守秘義務を負うアドバイザー
          （以下「外部専門家」という。）及び被計測者に対して、秘密情報を開示することができます。
          この場合において、当社及び利用者は、秘密情報の開示を受けた外部専門家及び被計測者をして
          本契約上の義務と同様の義務を負わせなければなりません。
        </p>
        <p>
          4.
          第1項の定めにかかわらず、行政当局、司法機関その他の公的機関、
          金融商品取引所等から、法令（金融商品取引所の定める規則も含む。）
          上の権限に基づき開示請求があった場合、当社及び利用者は、
          当該秘密情報を開示することができます。この場合において、可能な範囲で
          事前に相手方への通知を行わなければなりません。
        </p>
        <p>
          5.
          本条の規定は、利用契約の終了後も引き続き効力を有するものとします。
        </p>

        <h2>第11条 （本規約等の変更）</h2>
        <p>
          1.
          当社は、必要と判断した場合には、本規約又は本サービスの内容をいつでも変更できます。
          ただし、第6条（個人情報等の取扱い）及び第10条（守秘義務）の規定は、この限りではありません。
        </p>
        <p>
          2.
          本規約の内容を変更する場合、当社は事前に、利用者に対し当該変更を通知します。
          なお、当該変更後も利用者が本サービスの利用を継続した場合、
          利用者は当該変更に対して取り消し不可能な承諾をしたものとみなされます。
        </p>


        <h2>第12条 （サービス提供の一時中断又は停止等）</h2>
        <p>
          1.
          当社は、次の各号のいずれかに該当する場合には、利用者への事前の通知又は承諾を要することなく、
          本サービスの提供を一時中断することができます。
        </p>
        <ol class="no-style-list">
          <li>(1) 本サービスに係る設備、機器の故障等により保守又は点検作業を行う場合</li>
          <li>(2) 利用者のパスワード等が第三者に使用された場合</li>
          <li>(3) 運用上又は技術上の理由でやむを得ない場合</li>
          <li>(4) 本製品に係る改善作業を行う場合</li>
          <li>(5) 戦争、暴動、労働争議、天災地変（地震、噴火、洪水、津波等）、火災、停電その他の非常事態により、本サービスの提供ができなくなった場合</li>
          <li>(6) その他当社が必要と認めた場合</li>
        </ol>
        <p>
          2.
          当社は、次の各号のいずれかに該当する場合、利用者に通知の上直ちに本サービスの利用を停止し、
          パスワード等の削除、利用契約の解除その他の措置を取ることができます。
        </p>
        <ol class="no-style-list">
          <li>(1) 利用者が本規約又は利用契約の定めに違反したとき</li>
          <li>(2) 第6条第2項に定める個人情報の提供に係る承諾が得られていないことが明らかとなったとき</li>
          <li>(3) 利用料の支払いが2回連続で遅延したとき</li>
          <li>(4) 利用者に重大な財務状況の悪化が認められる相当の事情が生じたとき</li>
          <li>(5) 利用者が届け出た情報に基づく当社と利用者との連絡が2ヶ月間、不可能なとき</li>
          <li>(6) 利用者及び被計測者に関して利用者が届け出た情報について、不正な利用又は虚偽の申告等、不適切な行為があったとき</li>
          <li>(7) 当社の責に帰さない事由により、本サービスの提供が事実上不可能になったとき</li>
          <li>(8) その他合理的な事由により、本サービスの利用者として不適切と当社が判断したとき</li>
        </ol>
        <p>
          3.
          当社は、前各項に定める事由のいずれかにより本サービス提供の中断若しくは停止又は
          利用契約の解除をしたことに関して利用者、被計測者又はその他の第三者が損害を被った場合であっても、
          なんら法的な義務及び責任を負わないものとします。
        </p>
        <p>
          4.
          利用者は、第2項に定める事由のいずれかにより利用契約が解除された場合、
          解除時点までの未払いの利用料全額を支払わなければなりません。
        </p>
        <p>
          5.
          当社は、事業上の理由等当社が必要と認めた場合、事前に利用者に通知のうえ、
          本サービスを停止し、利用契約を解除することができます。この場合において、
          当社は、なんら法的な義務及び責任を負わないものとします。
        </p>

        <h2>第13条 （本サービスの中止）</h2>
        <p>
          1.
          当社は、理由の如何にかかわらず、利用者に対する通知の上、
          本サービスの提供を中止することができます。
        </p>
        <p>
          2.
          前項に定める通知は、本サービスの提供中止の60日前までに、
          第5条の定めに従い、本サービスのホームページ上にその旨掲載することによって行います。
        </p>
        <p>
          3.
          当社は本サービスの提供中止の際、本条に定める手続を経ることで、
          中止に伴う利用者又は第三者に対する損害賠償その他一切の責任を免れるものとします。
        </p>


        <h2>第14条 （本サービスの提供主体の変更）</h2>
        <p>
          当社は、事業譲渡、会社分割その他方法の如何を問わず、本サービスの提供主体を
          第三者である法人、組織団体又は当社の後継組織（以下「変更先」という。）に
          変更できるものとします。このとき、変更先は、当社が利用者に対して持つ全ての権利及び義務
          並びにパスワード等その他の利用者に関する情報及び利用情報を引き継ぐことができるものとし、
          利用者は、かかる権利、義務及び情報の移転につき予め同意するものとします。
          その場合、当社は、利用者に対し、本サービスの提供主体の変更の１ヶ月前までに、
          第5条の定めに従って通知するものとします。
        </p>

        <h2>第15条 （無保証）</h2>
        <p>
          1.
          当社は、本サービス並びに本サービスに含まれる本機器等及びデータの品質、機能、有用性、妥当性、
          その他あらゆる面に関して、一切の表明や保証を行いません。
        </p>
        <p>
          2.
          当社は、本サービスの安全性、完全性及び信頼性並びに本サービスの利用による
          被計測者の健康状態の良化を保証するものではなく、利用者が本サービスを利用した結果
          及び被計測者が実際に本製品を使用した結果について、なんら法的な義務及び責任を
          負わないものとします。
        </p>
        <p>
          3.
          利用者は、本機器等の利用に際して、本機器等において提供される情報やサービスの有用性等を
          自ら判断し、自己の責任で利用するものとします。
        </p>
        <p>
          4.
          当社は、次の各号について、一切保証しないものとします。
        </p>
        <ol class="no-style-list">
          <li>(1) 本サービス及び本機器等において提供される全ての情報に関する、有用性、適合性、完全性、正確性、安全性、合法性、最新性等</li>
          <li>(2) 利用者が本機器等上において提供される情報を利用して第三者と交渉又は予約、もしくは契約の申込又は締結等を行う場合において、当該行為に関する一切</li>
          <li>(3) 本サービス及び本機器等を通じて入手できる商品、役務、情報等が利用者の希望又は期待を満たす適切なものであること</li>
          <li>(4) 本サービス及び本機器等の提供に不具合、エラー又は障害が生じないこと</li>
          <li>(5) 本サービス及び本機器等に関連して送信される電子メール、ウェブコンテンツ等に、コンピュータ・ウィルス等の有害なものが含まれていないこと</li>
        </ol>

        <h2>第16条 （責任の範囲）</h2>
        <p>
          1.
          本サービスには、当社が提供するサービス又は情報を含みます。
          その場合には、当該サービス又は情報には、各事業者が定める利用規約又は契約
          その他の条件が適用され、その責任は、これを提供する事業者が負います。
        </p>
        <p>
          2.
          当社は、本規約若しくは本サービスの変更又は利用者が当社からの通知の確認を怠ったことにより
          損害を被った場合であっても、なんら法的な義務及び責任を負わないものとします。
        </p>
        <p>
          3.
          利用者は、には、自己の費用と責任において一切を処理するものとし、
          当社は当該紛争につきなんら責任を負わないものとします。
        </p>
        <p>
          4.
          当社は、利用者の本サービス及び本機器等の利用（これらに伴う当社又は第三者による情報提供行為等を含み、
          これらに限られない。）又は利用不能により生じる一切の損害（本項各号に定める損害や、
          前項により利用者又は第三者に生じた損害、精神的苦痛、又はその他の金銭的損失を含む一切の不利益を含み、
          これらに限られない）につき、当社に故意又は重過失がない限り、一切その責任を負わないものとする。
        </p>
        <ol class="no-style-list">
          <li>(1) 本機器等の無断改変、本機器等に関するデータへの不正アクセス、コンピュータ・ウィルスの混入等の不正行為が行われ、これに起因して利用者に生じた損害</li>
          <li>(2) 天災、火災、停電等不可抗力、システムの保守、通信回線やコンピューターの障害等による、当社のサーバーやシステム、本機器等の中断、遅延、中止、データ消失等により生じた損害</li>
          <li>(3) 本機器等において提供されるサービスの利用にあたって、利用者と第三者との間で生じたトラブルにより生じた損害並びに、本サービスの利用に関連して、被計測者又は第三者との間に紛争が生じた場合</li>
        </ol>
        <p>
          5.
          本サービスの提供に関し、当社の過失により利用者が受けた損害を賠償する場合、
          当社は直接かつ通常生じる損害の範囲で賠償するものとします。
        </p>

        <h2>第17条 （反社会的勢力）</h2>
        <p>
          1.
          利用者は、次の各号に該当しないことを表明保証し、
          将来にわたり該当しないことを誓約するものとします。
        </p>
        <ol class="no-style-list">
          <li>(1) 自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が、暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団その他これらに準ずるもの（以下総称して「反社会的勢力」という。）であること。</li>
          <li>(2) 自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が反社会的勢力と社会的に非難されるべき関係を有すること。</li>
          <li>(3) 前二号に該当しなくなったときから5年を経過していないこと。</li>
          <li>(4) 自ら又は第三者を利用して、当社に対し、次に掲げる行為又はこれに準ずる行為を行うこと。
            <ol class="no-style-list">
              <li>(a) 暴力的な要求行為</li>
              <li>(b) 法的な責任を超えた不当な要求行為</li>
              <li>(c) 取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
              <li>(d) 風説を流布し、偽計を用い又は威力を用いて、当社の信用を毀損し、又は当社の業務を妨害する行為</li>
            </ol>
          </li>
        </ol>
        <p>
          2.
          当社は、利用者が前項に違反している懸念が生じた場合は、随時調査を実施し、
          利用者に対して調査への協力及び資料の提出を求めることができます。
          この場合において、利用者は、調査に合理的な範囲で協力し、
          その範囲内で要請を受けた資料を提出しなければならないものとします。
        </p>
        <p>
          3.
          利用者は、第1項に違反した場合、直ちに当社に通知しなければなりません。
        </p>
        <p>
          4.
          当社は、利用者が次の各号のいずれかに該当する場合、催告することなく
          利用契約を解除できるものとします。この場合において、利用者に損害が生じた場合でも、
          当社はこれを賠償する責任を負いません。
        </p>
        <ol class="no-style-list">
          <li>(1) 第1項に違反したとき。</li>
          <li>(2) 第1項に違反している懸念が生じ、それにより利用契約を継続し難い状況が生じたとき。</li>
        </ol>
        <p>
          5.
          本条は、利用契約の終了後も引き続き3年間効力を有するものとします。
        </p>

        <h2>第18条 （管轄裁判所）</h2>
        <p>
          本規約及び利用契約に関する紛争解決のための準拠法は日本法とし、
          第一審の専属的合意管轄裁判所は、東京地方裁判所とします。
        </p>

        <h2>第19条 （疑義の解決）</h2>
        <p>
          本規約に定めのない事項又は疑義を生じた事項については、
          その都度利用者と当社の間で協議し、誠意をもって解決するものとします。
        </p>

        <p class="align-right">（以上）</p>


        <h2>附則</h2>
        <p>本規約は2022年8月1日から実施します。</p>

        <h2>附則</h2>
        <p>本規約の変更は2025年2月1日から実施します。</p>


      </mat-tab>
    </mat-tab-group>
  </mat-card>
  </div>
</div>
